module.exports = __webpack_public_path__ + "img/spruehverfahren.a7af300.png";